import { render, staticRenderFns } from "./PerformanceUnderPressure.vue?vue&type=template&id=452835be&scoped=true&"
import script from "./PerformanceUnderPressure.vue?vue&type=script&lang=js&"
export * from "./PerformanceUnderPressure.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceUnderPressure.vue?vue&type=style&index=0&id=452835be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452835be",
  null
  
)

export default component.exports